<template>
  <div class="b-share-wrapper">
    <!-- 250616 propsにsocialを追加して共有ボタン以外を非表示に変更。
    今後共有ボタン以外を使用しない想定だった場合、ソースから共有ボタン以外を削除してください。
    -->
    <!-- CRM汎用独自対応 -->
    <!-- <div class="item-action mobile-share">
      <template v-if="!social">
        <button v-if="copy" @click="doCopy">
          <span>共有</span>
          <i class="icon icon-bor-upload share"></i>
        </button>
      </template>
      <template v-else>
        <button @click="showShare">
          <span>共有</span>
          <i class="icon icon-bor-upload share"></i>
        </button>
      </template>
    </div> -->
    <div :class="['b-share', size ? size : '']">
      <!-- CRM汎用独自対応 -->
      <!-- <div v-if="social" class="b-share_inner pt-4 sm:hidden"> -->
      <div class="b-share_inner pt-4 sm:hidden">
        <span class="sm:hidden" :class="{ link: isHidden }">{{ label }}</span>
      </div>
      <!-- CRM汎用独自対応 -->
      <!-- <div class="b-share_inner"> -->
        <!-- <a
          class="b-share-item sm:hidden"
          :class="{ link: isHidden }"
          target="_blank"
          :href="shareFacebook"
          v-if="facebook"
        >
          <i class="icon icon-bor-facebook" />
        </a>
        <a
          class="b-share-item sm:hidden"
          :class="{ link: isHidden }"
          target="_blank"
          :href="shareTwitter"
          v-if="twitter"
        >
          <i class="icon icon-bor-twitter" />
        </a>
        <a
          class="b-share-item sm:hidden"
          :class="{ link: isHidden }"
          target="_blank"
          :href="shareLine"
          v-if="line"
        >
          <i class="icon icon-bor-line" />
        </a>
        <a
          class="b-share-item sm:hidden"
          :class="{ link: isHidden }"
          @click=";(popupMail = true), (errCode = '')"
          v-if="email"
        >
          <i class="icon icon-bor-envelope share" />
        </a> -->
        <!-- BOTTOM-MAIL -->
        <!-- <PopUpSendMail
          :visible="popupMail"
          @show="showPopup"
          @sendMail="sendMailToAddress($event)"
          :errCode="errCode"
        /> -->
        <!-- <div class="divider-v mt-6 sm:hidden" :class="{ link: isHidden }"></div>
        <div class="item-action sm:hidden" :class="{ link: isHidden }" v-if="copy">
          <button class="c-btn btn-sm btn-white btn-copy" @click="doCopy">
            内容をコピー
          </button>
        </div>
      </div> -->

      <div class="item-action" v-if="favorite">
        <a @click="handleFavorite">
          <i class="icon icon-bor-heart-solid" v-if="isFavorite" />
          <i class="icon icon-bor-heart" v-else />
        </a>
      </div>
    </div>

    <InstructionLogin2
      :visible="popupLogin"
      @ok="popupLogin = false"
      @cancel="popupLogin = false"
    />
    <!-- CRM汎用独自対応 -->
    <!-- <Modal :visible="popupShare" @ok="popupShare = false" @cancel="popupShare = false">
    <div class="b-share_inner"> -->
        <!-- <a
          class="b-share-item"
          :class="{ link: isHidden }"
          target="_blank"
          :href="shareFacebook"
          v-if="facebook"
        >
          <i class="icon icon-bor-facebook" />
        </a>
        <a
          class="b-share-item"
          :class="{ link: isHidden }"
          target="_blank"
          :href="shareTwitter"
          v-if="twitter"
        >
          <i class="icon icon-bor-twitter" />
        </a>
        <a
          class="b-share-item"
          :class="{ link: isHidden }"
          target="_blank"
          :href="shareLine"
          v-if="line"
        >
          <i class="icon icon-bor-line" />
        </a>
        <a
          class="b-share-item"
          :class="{ link: isHidden }"
          target="_blank"
          :href="shareEmail"
          v-if="email"
        >
          <i class="icon icon-bor-envelope share" />
        </a>
        <a
          class="b-share-item"
          :class="{ link: isHidden }"
          @click.stop="doCopy"
          v-if="copy"
        >
          <i class="icon icon-bor-copy" />
        </a> -->
      <!-- </div>
    </Modal> -->

    <!-- <div class="item-action mobile-share">
        <a href="#" @click="showShare">
          <span>共有</span>
          <i class="icon icon-bor-upload share"></i>
        </a>
    </div> -->
  </div>
</template>

<script>
import { cloneDeep, get } from 'lodash'
import menu_utils from '@/mixins/menu_utils'
import func_utils from '@/mixins/func_utils'

export default {
  name: 'Share',
  mixins: [menu_utils, func_utils],
  components: {},
  props: {
    label: {
      type: String,
      default: 'シェア'
    },
    url: {
      type: String
    },
    success: {
      type: Function
    },
    error: {
      type: Function
    },
    facebook: {
      type: Boolean,
      default: true
    },
    twitter: {
      type: Boolean,
      default: true
    },
    line: {
      type: Boolean,
      default: true
    },
    email: {
      type: Boolean,
      default: true
    },
    copy: {
      type: Boolean,
      default: true
    },
    face: {
      type: Boolean,
      default: true
    },
    isHidden: {
      type: Boolean,
      default: true
    },
    favorite: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    bodyEmail: {
      type: Object
    },
    copyLabel: {
      type: String,
      default: null
    },
    social: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menuNo: null,
      isFavorite: false,
      favoriteId: null,
      popupLogin: false,
      popupShare: false,
      popupMail: false,
      errCode: '0'
    }
  },
  created() {
    const { menuNo } = this.$route.query
    const menuNoParam = this.$route.params?.menuNo
    this.menuNo = menuNo || menuNoParam
  },
  mounted() {
    if (this.favorite) {
      this.getFavoriteStatus(this.menuNo).then(
        (result) => {
          this.favoriteId = get(result, 'id', '')
          this.isFavorite = get(result, 'favourite', false)
        },
        () => {}
      )
    }
  },
  watch: {
    menuNo() {
      this.isFavorite = false
    }
  },
  computed: {
    shareFacebook() {
      if (this.url) {
        return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`
    },
    shareTwitter() {
      if (this.url) {
        return `https://twitter.com/intent/tweet?text=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://twitter.com/intent/tweet?text=${url}`
    },
    shareLine() {
      if (this.url) {
        return `https://social-plugins.line.me/lineit/share?url=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://social-plugins.line.me/lineit/share?url=${url}`
    },
    shareEmail() {
      if (this.url) {
        return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${this.url}+&ui=2&tf=1&pli=1'`
      }
      // eslint-disable-next-line quotes
      return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${location.href}+&ui=2&tf=1&pli=1'`
    }
  },
  methods: {
    doCopy() {
      let label =''
      label = this.copyLabel
      let url = this.url
      if (!url) {
        url = location.href?.split('?')[0]
        if (this.$route?.query?.hasOwnProperty('adultHeadCnt')) {
          url = `${url}?adultHeadCnt=${this.$route.query.adultHeadCnt}`
        }
      }
      const copyData = [label, url].filter(Boolean).join('\n')
      this.$copyText(copyData).then(
        function (e) {
          alert('クリップボードにコピーしました')
        },
        function (e) {
          alert('クリップボードにコピーできませんでした')
        }
      )
    },
    handleFavorite() {
      if (!this.isFavorite) {
        this.addFavorite(this.menuNo).then(
          (result) => {
            this.isFavorite = true
            this.favoriteId = get(result, 'id', null)
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      } else {
        this.removeFavorite(this.favoriteId).then(
          () => {
            this.favoriteId = null
            this.isFavorite = false
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      }
    },
    sendMailToAddress($event) {
      if (!$event) {
        this.errCode = '1'
      } else {
        let myEmail = null
        myEmail = get($event, 'menuNo', '').trim()
        if (this.validEmail(myEmail.trim())) {
          const data = cloneDeep(this.bodyEmail)
          data.emailTo = myEmail
          data.typeShare = 2
          this.$loading.show()
          this.$repositories('plan')
            .sendMailToAddress(data)
            .then(
              () => {
                this.popupMail = false
                this.$loading.hide()
              },
              (error) => {
                this.popupMail = false
                this.$toasted.error(error?.message)
                this.$loading.hide()
              }
            )
        } else {
          this.errCode = '2'
        }
      }
    },
    showPopup($event) {
      this.popupMail = $event
    },
    showShare() {
      this.popupShare = true
    },
    triggerSuccess(type, data) {
      this.$emit('success', {
        type,
        data
      })
    },
    triggerError(type, data) {
      this.$emit('error', {
        type,
        data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
